import { render, staticRenderFns } from "./authenticationDetails.vue?vue&type=template&id=fa94dd12"
import script from "./authenticationDetails.vue?vue&type=script&lang=js"
export * from "./authenticationDetails.vue?vue&type=script&lang=js"
import style0 from "./authenticationDetails.vue?vue&type=style&index=0&id=fa94dd12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports